import { LayoutDashboard, Ticket, Search, CreditCard, Coins, UserCog } from 'lucide-react';

/**
 * SIGNED-IN CONTRACTOR NAVIGATION — one list, read by the header (desktop +
 * mobile) and the dashboard tab bar, so they can never disagree.
 *
 * Marketing audience links (Homeowners / Commercial / Contractors /
 * Subcontractors) are deliberately absent: a logged-in contractor already
 * knows who the site is for and only needs their own tools.
 *
 * ORDER = PRIORITY (owner request 2026-09-30):
 *   Credits · My Leads · Find Leads · Membership · Profile
 * "Dashboard" stays in the list for the header menu only (the tab bar is shown
 * ON the dashboard, so it does not repeat it). `short` labels fit a 5-column
 * phone tab bar without horizontal scrolling.
 */
export interface ContractorNavItem {
  key: 'dashboard' | 'leads' | 'find' | 'membership' | 'credits' | 'profile';
  to: string;
  en: string;
  es: string;
  shortEn: string;
  shortEs: string;
  icon: typeof LayoutDashboard;
}

export const MY_LEADS_PATH = '/my-leads';
export const CREDITS_PATH = '/membership?tab=credits';

export const CONTRACTOR_NAV: ContractorNavItem[] = [
  { key: 'dashboard', to: '/dashboard', en: 'Dashboard', es: 'Panel', shortEn: 'Home', shortEs: 'Inicio', icon: LayoutDashboard },
  { key: 'credits', to: CREDITS_PATH, en: 'Credits', es: 'Créditos', shortEn: 'Credits', shortEs: 'Créditos', icon: Coins },
  { key: 'leads', to: MY_LEADS_PATH, en: 'My Leads', es: 'Mis Leads', shortEn: 'My Leads', shortEs: 'Mis Leads', icon: Ticket },
  { key: 'find', to: '/jobs', en: 'Find Leads', es: 'Buscar Leads', shortEn: 'Find', shortEs: 'Buscar', icon: Search },
  { key: 'membership', to: '/membership', en: 'Membership', es: 'Membresía', shortEn: 'Plan', shortEs: 'Plan', icon: CreditCard },
  { key: 'profile', to: '/profile', en: 'Profile', es: 'Perfil', shortEn: 'Profile', shortEs: 'Perfil', icon: UserCog },
];

/** The five workspace tabs, in priority order (no Dashboard — you are on it). */
export const CONTRACTOR_TABS = CONTRACTOR_NAV.filter((i) => i.key !== 'dashboard');
